var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex h-full flex-grow flex-col justify-between gap-2" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex h-full flex-wrap content-center items-center gap-x-3 gap-y-4 transition-all duration-300",
          class: {
            "justify-center": !_vm.isCollapsed,
            "justify-between": _vm.isCollapsed
          }
        },
        [
          _vm.isCollapsed ? _c("div") : _vm._e(),
          _vm._v(" "),
          _vm.isCollapsed
            ? _c(
                "div",
                {
                  staticClass:
                    "flex flex-col items-center justify-between gap-2"
                },
                [
                  _c("BlTextTitle3", {
                    staticClass: "text-slate-800",
                    attrs: { text: _vm.totalScore }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", { attrs: { text: "Total score" } })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex flex-shrink-0 items-center justify-center rounded-full bg-light-purple hover:bg-dark-purple-200 transition-all duration-300 cursor-pointer",
              class: {
                "h-32 w-32 xl:h-48 xl:w-48": _vm.sessionStatus === "draft",
                "h-48 w-48": !_vm.isCollapsed && _vm.sessionStatus !== "draft",
                "h-24 w-24": _vm.isCollapsed && _vm.sessionStatus !== "draft",
                "cursor-wait": _vm.scoreLoading,
                "pointer-events-none": _vm.sessionStatus !== "ongoing"
              },
              on: {
                click: function($event) {
                  return _vm.onAddScore()
                }
              }
            },
            [
              _c("BlTextSubtitle3", {
                staticClass: "text-pure-white",
                attrs: { text: "Incident" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      !_vm.isCollapsed
        ? _c("div", { staticClass: "pb-3 flex-shrink-0 space-y-1" }, [
            _c(
              "div",
              { staticClass: "flex items-center justify-between" },
              [
                _c("BlTextBody2", { attrs: { text: "Interval" } }),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", { attrs: { text: _vm.currentInterval } }),
                    _vm._v(" "),
                    _c("BlTextBody2", { attrs: { text: "/" } }),
                    _vm._v(" "),
                    _c("BlTextBody2", { attrs: { text: _vm.intervalRound } })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center justify-between" },
              [
                _c("BlTextBody2", { attrs: { text: "Score in interval" } }),
                _vm._v(" "),
                _c("BlTextBody2", { attrs: { text: _vm.scoreInInterval } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center justify-between" },
              [
                _c("BlTextBody2", { attrs: { text: "Total score" } }),
                _vm._v(" "),
                _c("BlTextBody2", { attrs: { text: _vm.totalScore } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center justify-between" },
              [
                _c("BlTextBody2", { attrs: { text: "Percentage" } }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: { text: _vm.percentageScore + "%" }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51f284f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f284f0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sessions/card/PartialIntervalRecording.vue
// module id = null
// module chunks = 